import type { AdminUser } from "../api/adminUsers";

export type AdminUserSortField = "createdAt" | "alias";
export type AdminUserSortDirection = "asc" | "desc";

const getUserDisplayName = (user: AdminUser): string =>
  user.alias?.trim() || user.email?.trim() || "";

export const sortAdminUsers = (
  users: AdminUser[],
  field: AdminUserSortField,
  direction: AdminUserSortDirection
): AdminUser[] =>
  [...users].sort((left, right) => {
    let comparison = 0;

    if (field === "createdAt") {
      const leftTime = left.createdAt ? new Date(left.createdAt).getTime() : 0;
      const rightTime = right.createdAt ? new Date(right.createdAt).getTime() : 0;
      comparison = leftTime - rightTime;
    } else {
      comparison = getUserDisplayName(left).localeCompare(getUserDisplayName(right), "ru", {
        sensitivity: "base",
      });
    }

    return direction === "asc" ? comparison : -comparison;
  });

export const getNextAdminUserSort = (
  field: AdminUserSortField,
  currentField: AdminUserSortField,
  currentDirection: AdminUserSortDirection
): AdminUserSortDirection => {
  if (currentField !== field) {
    return field === "createdAt" ? "desc" : "asc";
  }

  return currentDirection === "asc" ? "desc" : "asc";
};
